// extracted by mini-css-extract-plugin
export var container = "carousel-module--container--b1499";
export var control = "carousel-module--control--71627";
export var controls = "carousel-module--controls--cae45";
export var indicators = "carousel-module--indicators--ea53a";
export var root = "carousel-module--root--30035";
export var slide = "carousel-module--slide--1414d";